import { UserLoginQueryDocument as __graphqlDocument0 } from 'store/client/documents/UserLoginQueryDocument'; 

export const userLoginQuery = __graphqlDocument0





















































































































;
